// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "index" + "d6cb8d9015587f6d98b3" + ".js";
};